const marketingString = `I consent to sign up for Unlock's member's list where I will receive marketing communication via text message, calls, email, or other outreach
channels. By doing so, I understand that I am allowing Unlock and its technology providers to retain my personal contact details/engagement history for use in 
personalized marketing. Opt-out at any time by using the remove from list link at the bottom of email communications or replying “stop” to text messages.`

async function postToGoogle(form) {
	try {
		var marketing = form.querySelector('input[name="Marketing"]')

		if (!marketing.checked) {
			return
		}

		var fName = form.querySelector('input[name="First Name"]')
		var lName = form.querySelector('input[name="Last Name"]')
		var title = form.querySelector('input[name="Title"]')
		var company = form.querySelector('input[name="Company"]')
		var email = form.querySelector('input[name="Email"]')
		var phone = form.querySelector('input[name="Phone Number"]')
		var service = form.querySelector('input[name="Service"]:checked')
		var message = form.querySelector('textarea[name="Message"]')

		var data = [
			{
				'entry.1248244043': fName.value,
			},
			{
				'entry.993656887': lName.value,
			},
			{
				'entry.701494011': title.value,
			},
			{
				'entry.1495181642': company.value,
			},
			{
				'entry.1796845714': email.value,
			},
			{
				'entry.512585955': phone.value,
			},
			{
				'entry.2051158645': service ? service.value : '',
			},
			{
				'entry.1141902047': message.value,
			},
			{
				'entry.1779025416': marketingString,
			},
		]

		let body = new FormData()
		data.forEach(entry => {
			let [key, value] = Object.entries(entry)[0]
			body.append(key, value)
		})

		const res = await fetch(
			'https://docs.google.com/forms/u/0/d/e/1FAIpQLSdhmfbhbGcZGJRMycduFUZvCfnUxhOlFBizS5ex3h5AlP6pCA/formResponse',
			{
				method: 'POST',
				mode: 'no-cors',
				body,
			}
		)
		await res.text()
	} catch {}
}

document.querySelectorAll('.pc-form').forEach(form => {
	const action = form.getAttribute('action')
	const method = form.getAttribute('method')
	form.addEventListener('submit', async e => {
		e.preventDefault()
		const statusOutput = form.querySelector('.status')
		const submitButton = form.querySelector('input[type=submit]')
		submitButton.disabled = true
		submitButton.value = 'Submitting...'
		const body = new FormData(form)
		const res = await fetch(action, {
			method,
			headers: {
				Accept: 'application/json',
			},
			body,
		})
		const { success } = await res.json()
		if (success) {
			submitButton.value = 'Submitted'
			statusOutput.classList.add('success')
			statusOutput.value =
				'Thank you for your message! We will be in touch soon.'
		} else {
			submitButton.value = 'Submit'
			submitButton.disabled = false
			statusOutput.classList.add('error')
			statusOutput.value =
				'Sorry, there was a problem sending your message. Please try again, or contact us at info@ourunlock.com.'
		}

		postToGoogle(form)
	})
})
